import React from 'react';
import { LazySellerPageDesBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const DesBanner = () => (
    <BannerWrapper>
        <LazySellerPageDesBanner />
    </BannerWrapper>
);
